/*eslint-disable array-callback-return */
/*eslint-disable linebreak-style */
/*eslint-disable eqeqeq */
/*eslint-disable no-redeclare */
/*eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import './header.scss';
import { Row, Container, Col } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useLocation, Link } from 'react-router-dom';
import httpheader from 'src/Member/shared/httpheader';
import PortalName from './PortalName';
import './portalName.scss';

export default function PublicHeader() {
  const { isLogoLoaded, logoImage, logoType } = useSelector(
    (state) => state.theme,
  );
  const [isContentPage, setContentPage] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (
      location.pathname.includes('/member/page/') ||
      location.pathname.includes('/member/document/')
    ) {
      setContentPage(true);
    } else {
      setContentPage(false);
    }
  }, [location.pathname]);

  return (
    <header
      className={!isContentPage ? 'topHeader margin-bottom-70' : 'topHeader'}
    >
      <Container>
        <Row>
          <Col md={8}>
            <>
              <Link to="/member">
                {isLogoLoaded && (
                  <img
                    src={'data:' + logoType + ';base64, ' + logoImage}
                    alt="Company Logo"
                  />
                )}

                {/*{!isLogoLoaded && logoType === null && (
                (httpheader.getCNAME() === 'roundstone-test' || httpheader.getCNAME() === 'roundstone-dev') ? (<img src={require( '../../img/roundstone-logo.png' )} alt="Company Logo" />) :
                (<img src={require( '../../img/A1MLightLogo.svg' )} alt="Company Logo" />)
                )} */}
              </Link>
            </>
          </Col>
          <Col
            md={4}
            className="d-none d-md-flex flex-column justify-content-end m-auto header-portal-name-container pr-0"
          >
            <PortalName isPublic={true} />
          </Col>
        </Row>
      </Container>
    </header>
  );
}
